import { getCountries, getCountryCallingCode, parsePhoneNumber } from "libphonenumber-js/min";
const callingCodeCountryCache = {};
export const formatPrefix = (prefix) => {
    if (/^\+[0-9]{1,3}$/.test(prefix)) {
        return prefix;
    }
    if (prefix.length === 0) {
        return "";
    }
    return `+${prefix.replace(/[^0-9]/g, "")}`;
};
export const getCallingCodeForCountry = (country, fallback = "") => {
    let callingCode;
    try {
        callingCode = getCountryCallingCode(country).valueOf();
    }
    catch {
        callingCode = fallback;
    }
    return callingCode;
};
export const getCountryForCallingCode = (prefix) => {
    if (typeof prefix !== "string" || prefix.length === 0) {
        return "";
    }
    const callingCode = prefix.replace(/[^0-9]/g, "").valueOf();
    if (callingCodeCountryCache[callingCode] !== undefined) {
        return callingCodeCountryCache[callingCode];
    }
    const countries = getCountries();
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < countries.length; i++) {
        if (getCountryCallingCode(countries[i]).valueOf() === callingCode) {
            callingCodeCountryCache[callingCode] = countries[i].valueOf();
            return callingCodeCountryCache[callingCode];
        }
    }
    return "";
};
const fixCountryCode = (country) => {
    if (typeof country !== "string" || country.length !== 2) {
        return "";
    }
    const countryCode = country.toUpperCase().valueOf();
    return getCountries()
        .map((value) => value.valueOf())
        .includes(countryCode)
        ? countryCode
        : "";
};
export const getValidator = (value = "", defaultCountry) => {
    const countryCode = defaultCountry;
    let phoneNumber = null;
    try {
        phoneNumber = parsePhoneNumber(value, countryCode);
    }
    catch {
        phoneNumber = null;
    }
    let prefix = "";
    let formattedValue = value.replace(/[^+0-9 ]/g, "");
    // @ts-expect-error Check for typing
    let country = fixCountryCode(defaultCountry);
    let isValid = false;
    if (phoneNumber?.country !== undefined) {
        prefix = formatPrefix(phoneNumber.countryCallingCode.valueOf());
        country = phoneNumber.country.valueOf();
        formattedValue = phoneNumber.formatInternational();
        isValid = phoneNumber.isValid();
    }
    else if (countryCode !== undefined) {
        prefix = formatPrefix(getCallingCodeForCountry(countryCode));
        if (formattedValue === "") {
            formattedValue = prefix;
        }
    }
    return {
        getPrefix: () => prefix,
        getCountry: () => country,
        isValid: () => isValid,
        getFormattedValue: () => formattedValue,
        getValidatedValue: () => (isValid ? formattedValue.replace(/\s/g, "") : "")
    };
};
//# sourceMappingURL=phone-input-validator.js.map
